<template>
    <div slot="header">
      <h5 class="text-green-dark font-bold my-3 mx-2">
        Average units of Toxin Treatments
      </h5>
      <vs-tabs v-model="active" class="insightsTabs">
        <vs-tab label="By Brand">
          <BrandUnit></BrandUnit>
        </vs-tab>
        <vs-tab label="By Nurse">
          <BrandUnit byNurse :isStacked="true"></BrandUnit>
        </vs-tab>
        <vs-tab label="By Clinic">
          <BrandUnit byClinic :isStacked="true"></BrandUnit>
        </vs-tab>
      </vs-tabs>
    </div>
</template>


<script>
import BrandUnit from '../../components/insights/products/BrandUnit.vue';

export default {
  components: {
    BrandUnit,
  },
  props: {},
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style>
  .insightsTabs .vs-tabs--ul {
    overflow: auto
  } 
  .insightsTabs .vs-tabs--li button.vs-tabs--btn {
    padding: .5rem 1rem;
  }
</style>
